import Feature from "ol/Feature";
import Geolocation from "ol/Geolocation";
import PointGeom from "ol/geom/Point";
import { Vector as VectorLayer } from "ol/layer";
import Projection from "ol/proj/Projection";
import { Vector as VectorSource } from "ol/source";

import { layerStyles } from "@/gis/layer/styles";


export default class GeolocationLayer extends VectorLayer<any> {
  positionFeature: Feature<any>;
  geolocation!: Geolocation;

  constructor() {
    const positionFeature = new Feature();
    positionFeature.setStyle(layerStyles['geolocation']);

    const source = new VectorSource({
      features: [positionFeature]
    });

    super({
      source,
    });
    this.positionFeature = positionFeature
  }

  initGeolocation(projection: Projection): void {
    this.geolocation = new Geolocation({
      tracking: false,
      projection
    });
    this.geolocation.on('change:position', () => {
      const coordinates = this.geolocation.getPosition();
      // console.debug("geolocation:", coordinates);
      this.positionFeature.setGeometry(coordinates ? new PointGeom(coordinates) : undefined);
    });
  }
}
